function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "dct");

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 3,
  y: 3,
  width: 140.47,
  height: 140.47,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 179.24,
  y: 3,
  width: 140.47,
  height: 60.27,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 179.24,
  y: 83.2,
  width: 140.47,
  height: 60.27,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 355.47,
  y: 3,
  width: 140.47,
  height: 30.14,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  x: 355.47,
  y: 58.17,
  width: 140.47,
  height: 30.14,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  x: 355.47,
  y: 113.34,
  width: 140.47,
  height: 30.14,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 49.36,
  y: 224.84,
  width: 140.47,
  height: 60.27,
  transform: "translate(368.31 128.55) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: -30.84,
  y: 224.84,
  width: 140.47,
  height: 60.27,
  transform: "translate(288.11 208.75) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 64.43,
  y: 416.15,
  width: 140.47,
  height: 30.14,
  transform: "translate(559.62 289.72) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref12 =
/*#__PURE__*/
React.createElement("rect", {
  x: 9.26,
  y: 416.15,
  width: 140.47,
  height: 30.14,
  transform: "translate(504.45 344.89) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: -45.91,
  y: 416.15,
  width: 140.47,
  height: 30.14,
  transform: "translate(449.28 400.06) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref14 =
/*#__PURE__*/
React.createElement("rect", {
  x: 179.24,
  y: 177.91,
  width: 58.83,
  height: 58.83,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref15 =
/*#__PURE__*/
React.createElement("rect", {
  x: 260.88,
  y: 177.91,
  width: 58.83,
  height: 58.83,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref16 =
/*#__PURE__*/
React.createElement("rect", {
  x: 260.88,
  y: 259.55,
  width: 58.83,
  height: 58.83,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref17 =
/*#__PURE__*/
React.createElement("rect", {
  x: 179.24,
  y: 259.55,
  width: 58.83,
  height: 58.83,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref18 =
/*#__PURE__*/
React.createElement("rect", {
  x: 354.03,
  y: 177.91,
  width: 29.42,
  height: 58.83,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref19 =
/*#__PURE__*/
React.createElement("rect", {
  x: 354.03,
  y: 259.55,
  width: 29.42,
  height: 58.83,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref20 =
/*#__PURE__*/
React.createElement("rect", {
  x: 411,
  y: 177.91,
  width: 29.42,
  height: 58.83,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref21 =
/*#__PURE__*/
React.createElement("rect", {
  x: 411,
  y: 259.55,
  width: 29.42,
  height: 58.83,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref22 =
/*#__PURE__*/
React.createElement("rect", {
  x: 466.53,
  y: 177.91,
  width: 29.42,
  height: 58.83,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref23 =
/*#__PURE__*/
React.createElement("rect", {
  x: 466.53,
  y: 259.55,
  width: 29.42,
  height: 58.83,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref24 =
/*#__PURE__*/
React.createElement("rect", {
  x: 281.84,
  y: 345.55,
  width: 29.42,
  height: 58.83,
  transform: "translate(665.26 71.59) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref25 =
/*#__PURE__*/
React.createElement("rect", {
  x: 200.2,
  y: 345.55,
  width: 29.42,
  height: 58.83,
  transform: "translate(583.62 153.23) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref26 =
/*#__PURE__*/
React.createElement("rect", {
  x: 281.84,
  y: 402.52,
  width: 29.42,
  height: 58.83,
  transform: "translate(722.23 128.55) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref27 =
/*#__PURE__*/
React.createElement("rect", {
  x: 200.2,
  y: 402.52,
  width: 29.42,
  height: 58.83,
  transform: "translate(640.59 210.19) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref28 =
/*#__PURE__*/
React.createElement("rect", {
  x: 281.84,
  y: 458.05,
  width: 29.42,
  height: 58.83,
  transform: "translate(777.75 184.08) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref29 =
/*#__PURE__*/
React.createElement("rect", {
  x: 200.2,
  y: 458.05,
  width: 29.42,
  height: 58.83,
  transform: "translate(696.11 265.72) rotate(90)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref30 =
/*#__PURE__*/
React.createElement("rect", {
  x: 354.03,
  y: 354.15,
  width: 28.7,
  height: 28.7,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref31 =
/*#__PURE__*/
React.createElement("rect", {
  x: 411.36,
  y: 353.79,
  width: 28.7,
  height: 28.7,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref32 =
/*#__PURE__*/
React.createElement("rect", {
  x: 466.89,
  y: 354.15,
  width: 28.7,
  height: 28.7,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref33 =
/*#__PURE__*/
React.createElement("rect", {
  x: 354.93,
  y: 410.94,
  width: 28.7,
  height: 28.7,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref34 =
/*#__PURE__*/
React.createElement("rect", {
  x: 412.26,
  y: 410.58,
  width: 28.7,
  height: 28.7,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref35 =
/*#__PURE__*/
React.createElement("rect", {
  x: 467.79,
  y: 410.94,
  width: 28.7,
  height: 28.7,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref36 =
/*#__PURE__*/
React.createElement("rect", {
  x: 354.93,
  y: 466.46,
  width: 28.7,
  height: 28.7,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref37 =
/*#__PURE__*/
React.createElement("rect", {
  x: 412.26,
  y: 466.1,
  width: 28.7,
  height: 28.7,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var _ref38 =
/*#__PURE__*/
React.createElement("rect", {
  x: 467.79,
  y: 466.46,
  width: 28.7,
  height: 28.7,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 6
});

var SvgDct = function SvgDct(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "fe888c35-9c57-4581-ad52-7c47f907c39a",
    "data-name": "Layer 1",
    viewBox: "0 0 499.48 498.34",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDct, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dct.124d6253.svg";
export { ForwardRef as ReactComponent };